define('companiesDetailBodySubaccountsView',[
  'app',
  'module',
  'marionette',
  'backbone',
  'underscore',
  'companiesDetailBodySubaccountRowView',
  'template!companiesDetailBodySubaccountsView',
  'entities/prospection'
], function (
  App,
  Module,
  Marionette,
  Backbone,
  _,
  RowView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'companies-detail-subaccounts-view',
    childView: RowView,
    childViewContainer: 'tbody.subaccount-rows',

    ui: {
      selectAll: '.js-select-all',
      selectedCount: '.js-selected-count',
      addProspection: '.js-add-prospection'
    },

    events: {
      'change @ui.selectAll': 'onSelectAll',
      'click @ui.addProspection': 'onAddToProspection'
    },

    childEvents: {
      'selected': function (child) {
        App.navigate('customers/' + child.model.get('secId') + '/profile', {trigger: true});
      },
      'toggled': function () {
        this.renderSelection();
      }
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    onShow: function () {
      this.model.getEndUsers().done(_.bind(function (items) {
        this.collection.reset(items);
        this.renderSelection();
      }, this));
    },

    selected: function () {
      return this.collection.filter(function (m) { return !!m.get('selected'); });
    },

    renderSelection: function () {
      var n = this.selected().length;
      this.ui.selectedCount.text(n ? n + ' ' + _.i18n('common.selected', null, 'selected') : '');
      this.ui.addProspection.prop('disabled', !n);
      this.ui.selectAll.prop('checked', n > 0 && n === this.collection.length);
    },

    onSelectAll: function (e) {
      var on = !!e.currentTarget.checked;
      this.collection.each(function (m) { m.set('selected', on); });
      this.children.each(function (child) { child.$('.js-select').prop('checked', on); });
      this.renderSelection();
    },

    onAddToProspection: function () {
      var secIds = _.map(this.selected(), function (m) { return m.get('secId'); });
      App.request('prospection:enroll-many', { endUserSecIds: secIds }).done(_.bind(function () {
        if (this.isDestroyed) { return; }
        this.collection.each(function (m) { m.set('selected', false); });
        this.children.each(function (child) { child.$('.js-select').prop('checked', false); });
        this.renderSelection();
      }, this));
    }
  });
});

